import * as integration from '../../../integration'
import * as types from './types'
import * as alerts from '../alerts'
import routes from '../../../config/routes'
import { transformToQuery } from '../../../lib/transform'

// Timeline list metadata
export const receiveTimelineMetatada = (data) => ({
  type: types.RECEIVE_TIMELINE_LIST_METADATA,
  payload: data
})

// Timeline list
export const fetchTimeline = (value = true) => ({
  type: types.FETCH_TIMELINE_LIST,
  payload: value
})

export const receiveTimeline = (data, options) => ({
  type: types.RECEIVE_TIMELINE_LIST,
  payload: {
    data,
    options
  }
})

export const receiveFilters = (data) => ({
  type: types.RECEIVE_TIMELINE_LIST_FILTERS,
  payload: data
})

export const removeFilters = (filters) => ({
  type: types.REMOVE_TIMELINE_LIST_FILTERS,
  payload: filters
})

export const resetFilters = () => ({
  type: types.RESET_TIMELINE_LIST_FILTERS
})

export const cleanTimeline = () => ({
  type: types.CLEAN_TIMELINE_LIST
})

export const postInteration = () => ({
  type: types.POST_INTERATION
})

export const doneInteration = () => ({
  type: types.DONE_INTERATION
})

export const getTimeline =
  (options = {}) =>
  async (dispatch, getState) => {
    dispatch(fetchTimeline())

    const {
      // eslint-disable-next-line camelcase
      filters: { period, store_tab_numbers, partner_std_code, indicators }
    } = getState().timelineReducer

    const params = transformToQuery({
      period,
      'store_tab_numbers[]': store_tab_numbers,
      indicators,
      partner_std_code,
      ...options
    })

    try {
      const res = await integration.resources.timeline.requests.getTimelineList(
        params
      )

      const { data, pagination } = res
      dispatch(receiveTimeline(data, { increment: options.increment }))
      dispatch(receiveTimelineMetatada(pagination))

      return res
    } catch (err) {
      dispatch(fetchTimeline(false))

      return Promise.reject()
    }
  }

export const receiveFiltersAndGetTimeline = (filters, options = {}) => [
  receiveFilters(filters),
  getTimeline(options)
]

export const removeFiltersAndGetTimeline = (filters, options = {}) => [
  removeFilters(filters),
  getTimeline(options)
]

export const resetFiltersAndGetTimeline = () => [resetFilters(), getTimeline()]

// eslint-disable-next-line consistent-return
export const post = (data) => async (dispatch) => {
  dispatch(postInteration())

  try {
    await integration.resources.timeline.requests.postInteration(data)

    dispatch(doneInteration())
    dispatch(getTimeline())

    dispatch(
      alerts.actions.receiveAlert({
        title: 'Sucesso',
        message: 'Interação adicionada com sucesso',
        action: 'redirect',
        route: routes.timeline.path
      })
    )

    return true
  } catch (err) {
    dispatch(doneInteration())

    if (err.error.status === 409) {
      dispatch(
        alerts.actions.receiveAlert({
          title: 'Item duplicado',
          message: 'Registro já existente',
          action: 'default'
        })
      )
    } else {
      dispatch(
        alerts.actions.receiveAlert({
          title: 'Erro ao inserir uma nova interação',
          message: 'Por favor tente novamente',
          action: 'default'
        })
      )
    }
  }
}

export const fetchPriorityMatricesByStore = (payload = true) => ({
  type: types.FETCH_TIMELINE_MATRIZ_PRIORITIES_BY_CLIENT,
  payload
})

export const receivePriorityMatricesByStore = (payload) => ({
  type: types.RECEIVE_TIMELINE_MATRIZ_PRIORITIES_BY_CLIENT,
  payload
})

export const clearPriorityMatricesByStore = () => ({
  type: types.CLEAR_TIMELINE_MATRIZ_PRIORITIES_BY_CLIENT
})

export const getPriorityMatricesByStore = (store) => async (dispatch) => {
  try {
    dispatch(fetchPriorityMatricesByStore())
    const res =
      await integration.resources.filters.requests.getPriorityMatrices({
        store_wallet_identifiers: [store]
      })

    dispatch(receivePriorityMatricesByStore(res.data))

    return res
  } catch (err) {
    return Promise.reject(err)
  } finally {
    dispatch(fetchPriorityMatricesByStore(false))
  }
}
